// extracted by mini-css-extract-plugin
export var callCard = "_s7-0";
export var callMessageButton = "_s7-1";
export var helpIcon = "_s7-3";
export var helpIconContainer = "_s7-4";
export var verticalDivider = "_s7-2";